var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 49,
    viewBox: "0 0 53 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5838)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2932 13.5262C20.2947 13.3861 20.352 13.2523 20.4527 13.1538C20.5534 13.0553 20.6892 13 20.8309 13H32.1691C32.3106 12.9999 32.4463 13.0552 32.5467 13.1538C32.6471 13.2524 32.7039 13.3863 32.7048 13.5262V16.4188L36.6403 17.4661C36.9038 17.534 37.0568 17.8241 36.9803 18.1069L34.6128 26.8487L34.6122 29.468C34.6122 29.6091 34.5556 29.7444 34.4547 29.8442C34.3539 29.944 34.2171 30 34.0745 30H18.9232C18.7806 30 18.6438 29.944 18.543 29.8442C18.4421 29.7444 18.3855 29.6091 18.3855 29.468V24.8966L16.0347 18.5075C15.9338 18.2325 16.0607 17.9321 16.3168 17.8401L20.2932 16.4082V13.5262ZM28.4554 15.2881L31.9697 16.2232V13.7256H21.0282V16.1435L27.3986 13.8495C27.655 13.7574 27.947 13.9068 28.0484 14.1818L28.4554 15.2881ZM34.4572 17.759C34.3564 17.6592 34.2196 17.6031 34.077 17.6031H29.3073L28.762 16.1211L36.2198 18.1056L34.6134 24.0371L34.6147 18.1351C34.6147 17.994 34.558 17.8587 34.4572 17.759ZM16.7923 18.4412L18.3855 22.7713V18.1351C18.3855 18.0266 18.419 17.9214 18.4804 17.8333L16.7923 18.4412ZM27.4248 14.6124L28.5253 17.6031H19.1195L27.4248 14.6124ZM31.812 22.0721C31.783 22.084 31.7519 22.0901 31.7206 22.0901H27.1862V20.9095H31.7206C31.7839 20.9095 31.8446 20.9344 31.8893 20.9787C31.9341 21.023 31.9592 21.083 31.9592 21.1456V21.8536C31.9593 21.8846 31.9531 21.9153 31.9412 21.944C31.9292 21.9727 31.9116 21.9988 31.8895 22.0208C31.8673 22.0427 31.841 22.0602 31.812 22.0721ZM31.8892 26.5068C31.8444 26.551 31.7838 26.5758 31.7206 26.5758H27.1862V25.3952H31.7206C31.7839 25.3952 31.8446 25.4201 31.8893 25.4644C31.9341 25.5087 31.9592 25.5687 31.9592 25.6313V26.3401C31.9591 26.4026 31.9339 26.4626 31.8892 26.5068ZM32.6053 24.2634C32.5605 24.3076 32.4998 24.3325 32.4365 24.3325H27.1862V23.152H32.4365C32.4998 23.1521 32.5604 23.177 32.6052 23.2212C32.6499 23.2655 32.6751 23.3255 32.6752 23.3881V24.0964C32.6752 24.159 32.65 24.2191 32.6053 24.2634ZM25.8709 23.8075C25.8702 23.6278 25.8551 23.4484 25.8258 23.271H23.1295V24.335H24.6735C24.5461 24.9836 23.9703 25.4537 23.1295 25.4537C22.1922 25.4537 21.4337 24.6693 21.4337 23.742C21.4337 22.8148 22.1939 22.0303 23.1295 22.0303C23.5378 22.0238 23.9324 22.1763 24.228 22.4551L25.0453 21.6465C24.5268 21.1652 23.84 20.9012 23.1291 20.9099C22.7501 20.9054 22.374 20.9754 22.0226 21.1157C21.6712 21.2561 21.3514 21.4641 21.0818 21.7276C20.8122 21.9911 20.5982 22.305 20.4521 22.6509C20.306 22.9969 20.2308 23.3681 20.2308 23.7431C20.2308 24.118 20.306 24.4892 20.4521 24.8352C20.5982 25.1812 20.8122 25.495 21.0818 25.7585C21.3514 26.0221 21.6712 26.23 22.0226 26.3704C22.374 26.5107 22.7501 26.5807 23.1291 26.5762C24.7835 26.5762 25.8709 25.4259 25.8709 23.8075Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5838",
    x: -4,
    y: -5,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.52549 0 0 0 0 0.898039 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5838",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3415f006715b46c34cb3285519e611d1.svg";
export { ForwardRef as ReactComponent };